import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Transition as _Transition, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  style: {"z-index":"1000"},
  class: "fixed top-0 left-0 flex items-center justify-center w-full h-full"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  style: {"width":"100vw !important","height":"100vh !important"},
  class: "fixed z-10 w-full h-full transition-none bg-gray-900 opacity-80"
}, null, -1)
const _hoisted_3 = { class: "flex items-center w-full mb-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, "close", -1)
const _hoisted_5 = { class: "div flex items-center space-x-2 text-muted rounded-sm py-1 mb-2 lg:w-max" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-lg" }, "info", -1)
const _hoisted_7 = { class: "text-sm" }
const _hoisted_8 = { class: "flex md:flex-row w-full h-full pb-10 flex-col md:space-x-8 overflow-y-auto" }
const _hoisted_9 = { class: "w-full h-full md:h-auto md:order-1 order-2 mt-4 md:mt-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1 mr-1 text-base material-icons" }, " play_arrow ", -1)
const _hoisted_11 = {
  key: 0,
  class: "opacity-50"
}
const _hoisted_12 = {
  key: 1,
  class: "opacity-0"
}
const _hoisted_13 = {
  key: 0,
  class: "absolute bottom-20 right-0 z-50 flex items-center px-6 py-3 mb-2 mr-4 space-x-2 rounded bg-dark text-lightText bg-opacity-90 shadow-popup"
}
const _hoisted_14 = { class: "md:order-2 order-1 w-full h-full md:h-auto overflow-y-auto" }
const _hoisted_15 = { class: "flex items-center px-10 py-3 -mx-10 -mb-6 shadow-popup bg-light" }
const _hoisted_16 = {
  key: 0,
  class: "ml-6 text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_TextEditor = _resolveComponent("TextEditor")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_CodeEditor = _resolveComponent("CodeEditor")!
  const _component_SegmentedControls = _resolveComponent("SegmentedControls")!
  const _component_FullExercise = _resolveComponent("FullExercise")!
  const _component_CodeExecutionResults = _resolveComponent("CodeExecutionResults")!
  const _component_CloudSaveStatus = _resolveComponent("CloudSaveStatus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      style: _normalizeStyle(
				_ctx.mediaQueryMdMatches ? 'min-height: 24rem; max-height: 40rem' : 'height: 100vh'
			),
      class: "fixed bottom-0 left-0 z-20 flex flex-col w-full px-10 py-6 bg-gray-50 shadow-all-around"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("exercise_solution.propose_solution_title")), 1),
        _createVNode(_component_Btn, {
          variant: 'icon',
          class: "ml-auto",
          outline: true,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
          tooltip: _ctx.$t('misc.close')
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["tooltip"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("exercise_solution.copyright_disclaimer")), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (_ctx.editorType === 'text')
            ? (_openBlock(), _createBlock(_component_TextEditor, {
                key: 0,
                tall: true,
                class: "mt-auto",
                modelValue: _ctx.modelValue.content,
                placeholder: _ctx.$t('exercise_solution.your_solution_placeholder'),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.onUpdate('content', $event)))
              }, null, 8, ["modelValue", "placeholder"]))
            : (_openBlock(), _createBlock(_component_CodeEditor, {
                key: 1,
                showRunButton: false,
                runCoolDown: _ctx.runCoolDown,
                running: _ctx.runningCode || _ctx.runCoolDown > 0,
                size: 'lg',
                modelValue: _ctx.modelValue.content,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.onUpdate('content', $event))),
                language: _ctx.editorType
              }, {
                runButton: _withCtx(() => [
                  _hoisted_10,
                  _createTextVNode(_toDisplayString(_ctx.$t("programming_exercise.run_code")) + " ", 1),
                  (_ctx.runCoolDown > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, " (" + _toDisplayString(_ctx.runCoolDown) + ")", 1))
                    : _createCommentVNode("", true),
                  (_ctx.runCoolDown < 10)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, "0"))
                    : _createCommentVNode("", true)
                ]),
                bottom: _withCtx(() => [
                  _createVNode(_Transition, { name: "quick-bounce" }, {
                    default: _withCtx(() => [
                      (_ctx.runningCode)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createVNode(_component_Spinner, { fast: true }),
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t("programming_exercise.running_code")), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["runCoolDown", "running", "modelValue", "language"]))
        ]),
        _createElementVNode("div", _hoisted_14, [
          (false && _ctx.editorType !== 'text')
            ? (_openBlock(), _createBlock(_component_SegmentedControls, {
                key: 0,
                class: "mb-4",
                modelValue: _ctx.currentTab,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentTab) = $event)),
                options: _ctx.programmingExerciseTabsOptions
              }, null, 8, ["modelValue", "options"]))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode(_component_FullExercise, {
            showTags: false,
            exercise: _ctx.exercise
          }, null, 8, ["exercise"]), [
            [_vShow, _ctx.currentTab === _ctx.ProgrammingExerciseTabs.TEXT]
          ]),
          _withDirectives(_createVNode(_component_CodeExecutionResults, {
            reduced: true,
            testCases: _ctx.exercise.testcases ?? [],
            executionResults: _ctx.executionResults
          }, null, 8, ["testCases", "executionResults"]), [
            [_vShow, _ctx.currentTab === _ctx.ProgrammingExerciseTabs.EXECUTION_RESULTS]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_Btn, {
          disabled: _ctx.publishing || _ctx.modelValue.content.trim().length === 0,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSubmit()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.publishing
							? _ctx.$t("exercise_solution.publishing")
							: _ctx.$t("exercise_solution.publish")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        (_ctx.modelValue.state === _ctx.ExerciseSolutionState.DRAFT)
          ? (_openBlock(), _createElementBlock("p", _hoisted_16, " (" + _toDisplayString(_ctx.$t("exercise_solution.states." + _ctx.ExerciseSolutionState.DRAFT)) + ") ", 1))
          : _createCommentVNode("", true),
        _createVNode(_component_CloudSaveStatus, {
          class: "ml-auto",
          saving: _ctx.saving,
          hadError: _ctx.savingError
        }, null, 8, ["saving", "hadError"])
      ])
    ], 4)
  ]))
}